module.exports = __webpack_public_path__ + "static/media/content-thuong-mai-3.c219ce93.jpg";